import React, { useEffect, useState } from "react";
import "./addUserModal.css";
import useraddcircle from "../../Assets/img/useraddcircle.png";
import tickCircle from "../../Assets/img/tickcircle.png";

import { Button, Checkbox, Form, Input, Select, Typography } from "antd";
import { RoleModalVar } from "../../Utils/variables";
import ButtonComp from "../ButtonComp/ButtonComp";
import { useDispatch, useSelector } from "react-redux";
import { onAddUserSubmit, onEditUserSubmit } from "../../API-Interaction/apiServices/plantSettings.api";
import { setPageLoader } from "../../Redux/features/utils.slice";
import { error } from "../../Helpers/notification";

const {
  role_name,
  capabilities,
  domain,
  demo,
  submit,
  email_address,
  password,
  define_role,
  lines,
  text,
} = RoleModalVar;

const { Text } = Typography;

const AddUserModal = ({ closeModal, type }) => {

  let { roleList = null } = useSelector(state => state?.roles)
  let { plant = null } = useSelector(state => state?.plant?.current)
  const accessControl = plant?.accessControl
  let dispatch = useDispatch()
  const [form] = Form.useForm()

  const onFinish = (values) => {
    if (accessControl.filter(item => item.email === values.email).length) {
      error("User already exist!")
      return
    }
    let selectedLineValues = plant?.productionLines?.filter((cvalue) => { return cvalue.id == values.lines })
    let roleDetails = roleList.filter(item => item._id === values.role)
    let updateAC = {
      accessControl: [
        ...accessControl,
        {
          email: values.email,
          lines: [{ id: selectedLineValues[0]?.id, lineName: selectedLineValues[0]?.lineName }],
          newUser: { password: values.password },
          role: roleDetails[0]?.role,
          roleId:roleDetails[0]?._id,
        },
      ],  
      _id: plant?._id
    }
    console.log("Selected Line Values:", selectedLineValues); 
    onAddUserSubmit(dispatch, values, updateAC)
    closeModal(1);
  };

  useEffect(() => {
    if (type.key === 3)
      form.setFieldsValue({
        email: type.value
      });
  }, [type])


  const onFinishEditUser = (values) => {

    let selectedLineValues = plant?.productionLines.filter((cvalue) => values.lines.includes(cvalue.id))
    let selectedAccessControlValues = plant?.accessControl.filter((cvalue) => cvalue.email !== values.email)
    console.log(selectedAccessControlValues)
    let roleDetails = roleList.filter(item => item._id === values.role)
    let updateAC = {
      accessControl: [
        ...selectedAccessControlValues,
        {
          email: values.email,
          lines: [{ id: selectedLineValues[0]?.id, lineName: selectedLineValues[0]?.lineName }],
          ...(values.password ? { updateUser: { password: values.password } } : {}),
          role: roleDetails[0]?.role,
          roleId:roleDetails[0]?._id,

        },
      ],
      _id: plant?._id
    }
    onEditUserSubmit(dispatch, updateAC)
    closeModal(1);
  };

  const passwordValidator = (rule, value, callback) => {
     if (!value) {
    callback("Please input your password!");
  } else {
    let errorMessage = "Password must ";
    if (value.length < 8) {
      errorMessage += "be at least 8 characters long";
    } else {
      if (!/[A-Z]/.test(value)) {
        errorMessage += "contain at least one uppercase letter";
      }
      if (!/[a-z]/.test(value)) {
        if (errorMessage !== "Password must ") {
          errorMessage += ", ";
        }
        errorMessage += "contain at least one lowercase letter";
      }
       if (!/\d/.test(value)) {
        if (errorMessage !== "Password must ") {
          errorMessage += ", ";
        }
        errorMessage += "contain at least one number";
      }
      if (!/[\W_]/.test(value)) {
        if (errorMessage !== "Password must ") {
          errorMessage += ", ";
        }
        errorMessage += "contain at least one special character";
      }
    }
    if (errorMessage === "Password must ") {
      callback();
    } else {
      errorMessage += ".";
      callback(errorMessage);
    }
  }
};

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      <Form
        form={form}
        name="basic"
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={type.key === 3 ? onFinishEditUser : onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="form"
      >
        <label className="b-3">{email_address}</label>
        <Form.Item
          name="email"
          rules={[
            {
              type: "email",
              message: "Invalid Email",
            },
            {
              required: true,
              message: "Please input your email!",
            },
          ]}
        >
          <Input
            className="border1"
            disabled={type.key === 3 ? true : false}
          />
        </Form.Item>

        <label className="b-3">
          {password}
          {type.key === 3 ? " (If you want to change)" : ""}
        </label>
        <Form.Item
          name="password"
          rules={[
            {
              validator: passwordValidator,
            },
          ]}
        >
          <Input.Password className="border1" />
        </Form.Item>

        <label className="b-3">{define_role}</label>

        <Form.Item
          name="role"
          rules={[
            { required: true, message: "Please Select Role" },
          ]}
        >
          <Select>
            {roleList?.length &&
              roleList.map((item) => (
                <Select.Option
                  key={JSON.stringify({
                    roleId: item.id,
                    role: item.role,
                  })}
                  value={item._id}
                >
                  {item.role}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <label className="b-3">{lines}</label>
        <Form.Item
          name="lines"
          rules={[
            {
              required: true,
              message: "Please select at least one production line",
            },
          ]}
        >
          <Select mode="multiple">
            {plant?.productionLines.map((line) => (
              <Select.Option key={line.id} value={line.id}>
                {line.lineName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Text className="text-color">{text}</Text>
        <br />
        <Form.Item className="btn-align">
          <ButtonComp
            theme="blue"
            text="Save"
            img={"tickcircle"}
            htmlType={"submit"}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddUserModal;
